const transformPayloadAttachments = async (payload, convertToFile = false) => {
    const processAttachments = async (obj) => {
        if (!obj || typeof obj !== 'object') return obj;

        const updatedObj = Array.isArray(obj) ? [...obj] : { ...obj };

        for (const key in updatedObj) {
            const value = updatedObj[key];

            if (key === 'attachments' && Array.isArray(value) && value.length > 0) {
                updatedObj[key] = await processAttachmentFiles(value, convertToFile);
            } else if (typeof value === 'object') {
                updatedObj[key] = await processAttachments(value);
            }
        }

        return updatedObj;
    };

    return processAttachments(payload);
};

const processAttachmentFiles = async (files, convertToFile) => {
    return Promise.all(
        files.map(async (file) => {
            if (convertToFile) {
                return base64ToFile(file.file_content, file.filename, 'application/pdf');
            }

            if (!file.file_content) {
                return fileToBase64(file);
            }

            return { filename: file.filename, file_content: file.file_content };
        })
    );
};

const fileToBase64 = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const base64String = reader.result.split(',')[1];
            resolve({
                filename: file.name,
                file_content: base64String
            });
        };
    });
};

const base64ToFile = (base64String, filename, mimeType) => {
    const byteString = atob(base64String);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new File([new Blob([ab], { type: mimeType })], filename, { type: mimeType });
};

export default transformPayloadAttachments;